import { Component, OnInit } from '@angular/core';
import {
  SchedulerEvent,
} from '@progress/kendo-angular-scheduler';
import {ActivatedRoute} from "@angular/router";
import {IEvent, ISearchSchedulerItemRequest} from "../models/scheduler";
import {ResourcePlanerEditService} from "../services/resource-planer-edit.service";
import {ResourcePlanerStoreService} from "../services/resource-planer-store.service";
import { IRessource } from 'src/app/setting/models/ressource';
import { ResourcePlanerService } from '../services/resource-planer.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IHoliday } from 'src/app/setting/holiday/model/holiday';
import { HolidayService } from 'src/app/setting/holiday/services/holiday.service';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { IAbsencePlanning, ISearchAbsenceGroupsRequest } from 'src/app/time-tracking/models/absence-group';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';

@UntilDestroy()
@Component({
    selector: 'app-resource-planer',
    templateUrl: './resource-planer.component.html',
    styleUrls: ['./resource-planer.component.css'],
    standalone: false
})
export class ResourcePlanerComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    public resourcePlanerEdit : ResourcePlanerEditService,
    private resourcePlanerStore : ResourcePlanerStoreService,
    private resourcePlanerService: ResourcePlanerService,
    private holidayService: HolidayService,
    private permissionStore: PermissionStorageService
  ) {
    this.resourcePlanerStore.listSchedulerItems();
  }

  showAssigmentList = false;
  isLoading = false;

  events: Array<SchedulerEvent> = [];

  // Every employee's absences (planning view); foreign ones arrive redacted to "absent".
  public absenceGroups: IAbsencePlanning[] = [];

  schedulerRessources: IRessource[];

  holidays: IHoliday[] = [];

  listSchedulerItemsRequest : ISearchSchedulerItemRequest = {
    pageNumber : 0,
    pageSize: 999999,
    start: new Date(new Date().setUTCHours(0,0,0,0)),
    end: new Date(new Date().setUTCHours(23,59,59,999))
  }

  listHolidayRequest : IBaseSearchRequest = {
    pageNumber: 0,
    pageSize: 999999,
    advancedFilter: {
      logic: "and",
      filters: [
        {
          field: "start",
          operator: "gte",
          value: new Date(new Date().setUTCHours(0,0,0,0)).toJSON()
        },
        {
          field: "end",
          operator: "lte",
          value: new Date(new Date().setUTCHours(23,59,59,999))
        }
      ]
    }
  }

  listAbsenceGroupRequest : ISearchAbsenceGroupsRequest = {
    pageNumber: 0,
    pageSize: 999999,
    start: new Date(new Date().setUTCHours(0,0,0,0)),
    end: new Date(new Date().setUTCHours(23,59,59,999))
  }

  ngOnInit(): void {
    this.events = this.route.snapshot.data["scheduler"] as IEvent[];
    this.schedulerRessources = this.route.snapshot.data["ressources"] as IRessource[];

    if (this.hasPermission('Permissions.Holidays.Search')) {
      this.holidays = this.route.snapshot.data["holidays"] as IHoliday[];
    }

    this.loadAbsences();
  }

  // The planning endpoint is guarded by the scheduler right every planner holds, so no extra gate.
  private loadAbsences(): void {
    this.resourcePlanerService.listAbsences(this.listAbsenceGroupRequest)
      .pipe(untilDestroyed(this))
      .subscribe(response => this.absenceGroups = response.data);
  }

  onReloadEvents(){
    Promise.resolve().then(() => this.isLoading = true);
    this.listAbsenceGroupRequest.start = this.listSchedulerItemsRequest.start;
    this.listAbsenceGroupRequest.end = this.listSchedulerItemsRequest.end;

    if (this.hasPermission('Permissions.Holidays.Search')) {
      this.listHolidayRequest.advancedFilter.filters[0].value = this.listSchedulerItemsRequest.start;
      this.listHolidayRequest.advancedFilter.filters[1].value = this.listSchedulerItemsRequest.end;

      this.holidayService.searchHolidays(this.listHolidayRequest)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.holidays = response.data
      })
    }

    this.resourcePlanerService.listEvents(this.listSchedulerItemsRequest)
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.events = response.data
      this.isLoading = false;
    })

    this.loadAbsences();
  }

  private hasPermission(permission: string): boolean {
    const permissions = this.permissionStore.getPermissions();
    return !!permissions?.find(p => p === permission);
  }

}
